import task from './task';
import tasklist from './tasklist';
import tasklists from './tasklists';
import milestone from './milestone';
import project from './project';
import person from './person';
import clockin from './clockin';
import gapps from './gapps';
import integration from './integration';
import card from './card';
import tags from './tags';
import importer from './importer';
import dataview from './dataview';

export default {
  task,
  tasklist,
  tasklists,
  milestone,
  project,
  person,
  clockin,
  gapps,
  integration,
  card,
  tags,
  finished: importer,
  dataview,
};
